import React from 'react';

const ReportAnnexureSection = ({ title, recordCount, children }) => (
  <div className="sm-annex-block sm-print-annex-block">
    <h3 className="sm-annex-block__title">{title}</h3>
    {recordCount != null && recordCount >= 0 ? (
      <p className="sm-annex-meta">Appendix register — {recordCount.toLocaleString('en-IN')} line item(s)</p>
    ) : null}
    <div className="sm-annex-body">{children}</div>
  </div>
);

export default ReportAnnexureSection;
